import styled from '@emotion/styled';
import { FixedGridItem } from '../../../../../../ui';
import { Row } from './Row';
import Responsive from '../../../../../../ui/utils/Responsive';

export const ActionsRow = styled(Row)`
	${FixedGridItem} {
		text-align: right;
		margin-top: 40px;

		${Responsive.getMediaQueryForBreakpoint('mobileXL')} {
			margin-top: 24px;
		}
	}
`;
